import { formatLaneKey, type PortNameLookup } from "@/lib/formatPort";
import { formatPersonName } from "@/lib/formatPersonName";

const LANE_PAIR = /\b[A-Za-z]{5}\s*(?:→|->|-)\s*[A-Za-z]{5}\b/g;
const SNAKE_IDENTIFIER = /\b[a-z][a-z0-9]*(?:_[a-z0-9]+)+\b/g;

export interface FormatInsightDisplayOptions {
  showLocodes: boolean;
  portNames?: PortNameLookup;
}

/**
 * Rewrite stored insight title/summary copy for display: locode lanes become
 * port names (plus codes when the user prefers them) and snake_case party
 * identifiers become Title Case names.
 */
export function formatInsightDisplayText(
  text: string | null | undefined,
  options: FormatInsightDisplayOptions,
): string {
  if (!text) return "";
  const withLanes = text.replace(LANE_PAIR, (lane) =>
    formatLaneKey(lane, options.showLocodes, options.portNames),
  );
  return withLanes.replace(SNAKE_IDENTIFIER, (token) => formatPersonName(token));
}
